/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';

/**
 * A component to render a WebChat Integration Icon.
 *
 * Original path data from assets/images/web-chat-gray.svg,
 *   added here after optimized by svgo
 *
 * @param {Object} props the properties for this component
 * @returns {Object} the JSX for this component
 */

interface WebChatIconProps {
  className?: string;
  size?: number;
  [key: string]: any;
}

export const WebChatIcon = ({
  className,
  size = 32,
  ...others
}: WebChatIconProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <svg
      className={cx('WebChatIcon', className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/1999/xlink"
      fillRule="evenodd"
      aria-labelledby="webchat-title"
      {...others}>
      <title id="webchat-title">{t(messages.webchat)}</title>
      <path d="M13.305 22.5L12 21.75l3-5.25h4.5A1.5 1.5 0 0021 15V6a1.5 1.5 0 00-1.5-1.5h-15A1.5 1.5 0 003 6v9a1.5 1.5 0 001.5 1.5h6.75V18H4.5a3 3 0 01-3-3V6a3 3 0 013-3h15a3 3 0 013 3v9a3 3 0 01-3 3h-3.63l-2.565 4.5zM6 7.5h12V9H6V7.5zM6 12h7.5v1.5H6V12z" />
    </svg>
  );
};
